// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"83829bb8","63":"f6f281ce","92":"0745a7b9","109":"93c5495e","237":"1fcd2f6f","263":"c0656c54","508":"7f6e909a","696":"dd7bc417","705":"c670368f","784":"0be71d12","864":"95b3eced","887":"16d06ae7"}[chunkId] + ".chunk.js";
};